module.exports = __webpack_public_path__ + "static/media/studyo-logo-white.ba5be285.svg";